import React from "react";
import "./Realestatebrokerage.css";
import Brokerageimage from "../../assets/دفع-العربون-brokrage.jpeg"; 
import logoimage from "../../assets/akari-logo.png";
import Footer from "../Footer";

const Realestatebrokerage = () => {
    return (
      <>
      
      <div className="heading-h1">
      <h1 className="title">Real Estate Brokerage Service</h1>
      </div>
      
        <div className="logo-container">
        <img src={logoimage} alt="Akari Logo" className="logo" />
        </div>
        
        <div className="image-container">
          <img src={Brokerageimage} alt="Center Image" className="center-image" />
        </div>
  
       <Footer/>
  
        
      
        
       
        
        </>
    );
  };
  
  export default Realestatebrokerage;
  